import { z } from 'zod';
import { OwnerCornSchema } from '../../owner/owner.js';
import { OwnerThemeSchema } from '../../owner/theme.js';
export const GetOwnerThemeApiSchema = {
    params: z.object({
        ownerId: OwnerCornSchema,
    }),
    response: OwnerThemeSchema,
};
export const GetOwnerThemePathSchema = GetOwnerThemeApiSchema.params;
export const GetOwnerThemeRequestSchema = GetOwnerThemePathSchema;
export const GetOwnerThemeResponseSchema = GetOwnerThemeApiSchema.response;
